import { render } from "./Control.vue?vue&type=template&id=3480d0f6&scoped=true"
import script from "./Control.vue?vue&type=script&lang=js"
export * from "./Control.vue?vue&type=script&lang=js"

import "./Control.vue?vue&type=style&index=0&id=3480d0f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3480d0f6"]])

export default __exports__